"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecProductImpression = void 0;
const buildGA4ProductInteractionEvent_1 = require("./buildGA4ProductInteractionEvent");
const pushToDataLayer_1 = require("./pushToDataLayer");
const buildEecProduct_1 = require("./buildEecProduct");
const enums_1 = require("../enums");
const clearGA4EventData_1 = require("./clearGA4EventData");
function trackEecProductImpression({ product, position, list, featureCategory, itemListName, itemListType, isLocationSelected, eventName, productTitle, }) {
    const isGA4EventEnabled = featureCategory && eventName;
    if (isGA4EventEnabled)
        (0, clearGA4EventData_1.clearGA4EventData)();
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: enums_1.EventName.EECProductImpression,
        ecommerce: {
            impressions: [
                {
                    ...(0, buildEecProduct_1.buildEecProduct)({ product, position }),
                    list: list || 'Category',
                },
            ],
        },
        ...(isGA4EventEnabled
            ? (0, buildGA4ProductInteractionEvent_1.buildGA4ProductInteractionEvent)({
                eventName,
                featureCategory,
                itemListName,
                itemListType,
                product,
                position,
                isLocationSelected,
                productTitle,
            })
            : undefined),
    });
}
exports.trackEecProductImpression = trackEecProductImpression;
//# sourceMappingURL=trackEecProductImpression.js.map